import { useUserStore } from "js/stores/userStore.js";

export const ACCESS = {
    GUEST: "guest",
    PUBLIC: "public",
    UNVERIFIED: "unverified",
};

export function createAuthGuard() {
    return (to) => {
        const access = to.meta?.access;
        const userStore = useUserStore();

        if (access === ACCESS.PUBLIC) {
            return true;
        }

        if (!userStore.isLoggedIn) {
            if (access === ACCESS.GUEST) {
                return true;
            }
            if (to.name === "home") {
                return { name: "landingPage" };
            }
            return { name: "login", query: { redir: to.fullPath } };
        }

        if (!userStore.user.isVerified && access !== ACCESS.UNVERIFIED) {
            return { name: "verify" };
        }

        if (userStore.user.isVerified && access === ACCESS.UNVERIFIED) {
            return { name: "home" };
        }

        if (access === ACCESS.GUEST) {
            return { name: "home" };
        }

        return true;
    };
}
